(function () {
    'use strict';

    var uploadImage = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/gallery/uplpadImage.html',
        controllerAs: 'userCtrl',
        bindings: {
            aid:'=',
            tag:'=',
            domain:'=',
            onUploadphoto:'&',
            photoAll:'=',
            folderOne:'=',
            status:'=',
            qiniuId:'=',
            choose:'=',
            uploadPhotoItem:'=',
            onUploadStart:'&'
        },

        controller: ['$scope', '$stateParams', '$q', '$localStorage', 'Qinius', 'QiniuToken', 'WxJS', 'Theme', 'Gallery','SweetAlert','$rootScope','ImageService','UidService','Upload','$timeout','$translate','$state',
            function ($scope, $stateParams, $q, $localStorage, Qinius, QiniuToken, WxJS, Theme, Gallery, SweetAlert,$rootScope,ImageService,UidService,Upload,$timeout,$translate,$state) {
                var vm = this;

                vm.duplicateList = []
                vm.currentFileList = []
                // 初始化大图提示相关状态
                $scope.bigSizeTip = false;
                $scope.higherSizeLen = 0;

                // 关闭大图提示弹框
                $scope.filterBigSize = function () {
                    $scope.bigSizeTip = false;
                    vm.higherSize = [];
                    $scope.higherSizeLen = 0;
                };

                // 成功多少张
                vm.indd = 0;
                vm.errorImageArr = [];
                vm.filesLength = 0;
                if (window.location.href.indexOf("?") > -1) {
                    // localStorage.removeItem('guide-step');
                    var r = window.location.href.split('?')[1];
                    var typeFlag = r.split('&')[0].split('=')[1];
                    var distinguish = decodeURIComponent(typeFlag);
                    if (distinguish == 'weChatApplet' || distinguish == 'weChatAppletMake') {
                        vm.uploadType = 'wechat';
                    }else if(distinguish == 'toutiaoApp'){
                        vm.uploadType = 'byteDance';
                    }else if(distinguish == 'alipayApp'){
                        vm.uploadType = 'ali';
                    }
                }else{
                    vm.uploadType = 'wechat';
                }

                if (wx) {
                    var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                    // var url = "https://stage.fotavatar.com/10/143/1230321120340111/editorPhotoBoth";
                    WxJS.get({url: url}, function (config) {
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.data.appId, // 必填，公众号的唯一标识
                            timestamp: config.data.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.data.nonceStr, // 必填，生成签名的随机串
                            signature: config.data.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'previewImage', 'uploadImage','getLocalImgData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            // console.log('editor: wechat api ready!');
                        });
                        wx.error(function (res) {
                            // alert("wx.error: "+res.errMsg)
                            // console.log(res);
                        });
                    }, function (res) {
                        // alert("data: "+res.data);
                        // alert("status: "+res.status);
                        // alert("statusText: "+res.statusText);
                        // console.log("editor: wx config error");
                    });
                }

                $scope.domains = Qinius.getDomain();
                vm.tokens = QiniuToken.getPromise('get', {"mimeLimit":"image/jpeg;image/png;image/jpg;image/heic"});
                $q.all([$scope.domains.$promise, vm.tokens.$promise]).then(function(){
                    $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                    vm.token = vm.tokens.token;
                    //安卓
                    $scope.$on('clickAndroidUpload', function(event, args) {
                        if(vm.uploadType=='ail'){
                            // my.postMessage({name:"测试web-view"});
                            ap.chooseImage(9, function(res){
                                vm.onUploadStart();
                                var files = []
                                for (var i = 0; i < res.apFilePaths.length; i++) {
                                    var tempFile = res.tempFiles[i];
                                    var fileName = tempFile.name || tempFile.fileName || tempFile.path && tempFile.path.split('/').pop() || '';
                                    files.push({
                                        localId:res.apFilePaths[i],
                                        blobCover:res.apFilePaths[i],
                                        imgSize:tempFile.size,
                                        fileName: fileName || 'IMG_' + Date.now() + '_' + i + '.jpg'
                                    })
                                }
                                var index = 0;
                                // readImages(index);
                                // function readImages(index){
                                //     ap.uploadFile({
                                //         url: ' /fileserves/api/convert/downloadImg4AliAngUpload7Niu',
                                //         fileType: 'image',
                                //         fileName: 'file',
                                //         filePath: '...',
                                //         header: {
                                //             'Content-Type': 'application/x-www-form-urlencoded',
                                //         },
                                //         success: function (resBackData) {
                                //             // alert(resBackData)
                                //         },
                                //         fail: function (res) {
                                //             // alert(res.errMsg);
                                //             console.warn("getLocalImgData fail",res);
                                //             $(".save-pages2").addClass('hide1');
                                //         }
                                //     });
                                // }
                                Gallery.upload({
                                    identifiers: res.apFilePaths[0],
                                    provider: "QINIU",
                                    fileName: files[0] && files[0].fileName ? files[0].fileName : generateFileName(),
                                    imgSize: files[0] && files[0].imgSize ? files[0].imgSize : 0,
                                    folderId: vm.folderOne ? vm.folderOne.id : null,
                                    check: true,
                                    type: vm.uploadType,
                                    articleId:vm.aid,
                                    hash:data.hash
                                }, function (resp) {

                                })
                                return
                            });
                            return;
                        }
                        vm.indd = 0;  //成功的张数
                        vm.errorImageArr = [];  //错误的张数
                        vm.duplicateList = []; //重复的张数

                        /********************************************
                         * 微信端上传图片功能
                         * 使用原生 <input type="file" multiple> 替代 wx.chooseImage + wx.getLocalImgData
                         * 优势：1) 可获取原始文件名  2) 可获取原图数据（不经微信JSSDK压缩）
                         * 与 iOS 端 uploadImageMutiple 流程保持一致
                         ********************************************/

                        // 创建隐藏的 file input 用于微信端选图
                        var wechatFileInput = document.createElement('input');
                        wechatFileInput.type = 'file';
                        wechatFileInput.accept = 'image/png, image/jpeg, image/jpg, .heic, .heif, .livp';
                        wechatFileInput.multiple = true;
                        wechatFileInput.style.display = 'none';
                        wechatFileInput.id = 'wechatUploadInput_directive';
                        document.body.appendChild(wechatFileInput);

                        wechatFileInput.onchange = function(event) {
                            $timeout(function() {
                                vm.onUploadStart();
                                $scope.bigSizeTip = false;
                                var files = [];
                                var rawFiles = event.target.files;
                                for (var i = 0; i < rawFiles.length; i++) {
                                    var file = rawFiles[i];
                                    var lowerName = (file.name || '').toLowerCase();
                                    var isValidImage = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/heic';
                                    var isHeicExt = !file.type && (lowerName.endsWith('.heic') || lowerName.endsWith('.heif'));
                                    var isLivp = !file.type && lowerName.endsWith('.livp');
                                    if (isValidImage || isHeicExt || isLivp) {
                                        file.usenum = 0;
                                        file.percent = 0;
                                        file.blobCover = URL.createObjectURL(file);
                                        files.push(file);
                                    }
                                }

                                if (files.length === 0) {
                                    try { document.body.removeChild(wechatFileInput); } catch (e) {}
                                    return;
                                }

                                $(".save-pages2").removeClass('hide1');

                                // 检查图片大小（文件大小 + 像素维度）
                                vm.higherSize = [];
                                var checkPromises = [];
                                angular.forEach(files, function (item) {
                                    item.imgSize = item.size;
                                    checkPromises.push(
                                        checkIsBigImage(item).then(function (isBig) {
                                            if (isBig) {
                                                vm.higherSize.push(item);
                                            }
                                        })
                                    );
                                });

                                $q.all(checkPromises).then(function () {
                                    if (vm.higherSize.length > 0) {
                                        $scope.bigSizeTip = true;
                                        $scope.higherSizeLen = vm.higherSize.length;
                                        $(".save-pages2").addClass('hide1');
                                        $timeout(function(){
                                            $scope.$digest();
                                        })
                                    } else {
                                        if (files.length > 0) {
                                            filterUpload(files);
                                        }
                                    }
                                    try { document.body.removeChild(wechatFileInput); } catch (e) {}
                                });
                            });
                        };

                        // 触发文件选择
                        wechatFileInput.click();
                    });

                    /**
                     * iOS上传
                     * 使用自带的上传图片功能  不调用微信的jssdk
                     * 非调用微信公众号上传图片 无9张限制 可多张上传 上传到七牛  并且可以返回路径在页面显示
                     * @param $event
                     */
                    window.uploadImageMutiple = function ($event) {
                        $timeout(function () {
                            vm.onUploadStart();
                            $scope.bigSizeTip = false;
                            var files = [];
                            for (var i = 0; i < $event.target.files.length; i++) {
                                var file = $event.target.files[i];
                                var lowerName = (file.name || '').toLowerCase();
                                var isValidImage = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/heic';
                                var isHeicOrLivp = !file.type && (lowerName.endsWith('.heic') || lowerName.endsWith('.heif') || lowerName.endsWith('.livp'));
                                if (isValidImage || isHeicOrLivp || !file.type) {
                                    file.usenum = 0;
                                    file.percent = 0;
                                    file.blobCover = URL.createObjectURL(file);
                                    files.push(file)
                                }
                            }

                            // 检查图片大小（文件大小 + 像素维度）
                            vm.higherSize = [];
                            var iosCheckPromises = [];
                            angular.forEach(files, function (item) {
                                item.imgSize = item.size;
                                iosCheckPromises.push(
                                    checkIsBigImage(item).then(function (isBig) {
                                        if (isBig) {
                                            vm.higherSize.push(item);
                                        }
                                    })
                                );
                            });
                            $q.all(iosCheckPromises).then(function () {
                                if (vm.higherSize.length > 0) {
                                    $scope.bigSizeTip = true;
                                    $scope.higherSizeLen = vm.higherSize.length;
                                    $(".save-pages2").addClass('hide1');
                                    $timeout(function(){
                                        $scope.$digest();
                                    })
                                } else {
                                    if (files.length > 0) {
                                        filterUpload(files);
                                    }
                                }
                            });
                        })

                    };
                });


                // 检测图片是否为大图（文件大小 > 50MB 或 像素数 > 4亿）
                function checkIsBigImage(item) {
                    return $q(function (resolve) {
                        // 文件大小检查
                        // 鸿蒙等系统可能存在 File.size 不可用的情况（为0或undefined），
                        // 此时先不做文件大小判断，改为通过 Image 加载后在 onload 中获取 blob 实际大小来判断
                        var fileSize = item.size;
                        if (fileSize && fileSize / 1024 > 51200) {
                            resolve(true);
                            return;
                        }

                        // 像素检查：width * height > 4亿
                        try {
                            var img = new Image();
                            var objectUrl = item.blobCover;
                            img.onload = function () {
                                var imgSrc = img.src;
                                // 先检查像素维度
                                if (this.naturalWidth * this.naturalHeight > 400000000) {
                                    URL.revokeObjectURL(imgSrc);
                                    resolve(true);
                                    return;
                                }
                                // 如果 File.size 不可用（为0或空），尝试通过 blob URL 估算实际文件大小
                                if (!fileSize || fileSize === 0) {
                                    // 通过 canvas 估算解码后的数据量作为参考
                                    // 如果 width * height * 4（RGBA字节数）> 50MB，也可以认为是大图
                                    // 50MB = 50 * 1024 * 1024 bytes
                                    var estimatedSize = this.naturalWidth * this.naturalHeight * 4;
                                    if (estimatedSize > 50 * 1024 * 1024) {
                                        URL.revokeObjectURL(imgSrc);
                                        resolve(true);
                                        return;
                                    }
                                }
                                URL.revokeObjectURL(imgSrc);
                                resolve(false);
                            };
                            img.onerror = function () {
                                URL.revokeObjectURL(img.src);
                                // 如果 file.size 本身就已经超过 50MB，直接判定为大图
                                if (fileSize && fileSize / 1024 > 51200) {
                                    resolve(true);
                                    return;
                                }
                                // 图片加载失败但文件大小未超标：很可能是像素过大导致浏览器无法解码
                                // 此时通过直接解析文件头部获取真实宽高，避免漏判大图
                                readDimensionsFromHeader(item).then(function(dims) {
                                    if (dims && dims.width * dims.height > 400000000) {
                                        resolve(true);
                                    } else {
                                        // 无法获取维度或维度正常，可能是图片损坏等其他原因导致加载失败
                                        resolve(false);
                                    }
                                }).catch(function() {
                                    resolve(false);
                                });
                            };
                            img.src = objectUrl;
                        } catch (e) {
                            // 异常兜底：如果能从 item 拿到 size 信息，就基于它判断
                            if (fileSize && fileSize / 1024 > 51200) {
                                resolve(true);
                            } else {
                                resolve(false);
                            }
                        }
                    });
                }

                /**
                 * 通过读取文件头部二进制数据，直接解析 JPEG/PNG 图片的宽高
                 * 用于 Image 对象解码失败时（如图片像素过大导致浏览器内存不足）的兜底方案
                 * @param {File|Blob} file - 图片文件对象
                 * @returns {Promise<{width: number, height: number}|null>}
                 */
                function readDimensionsFromHeader(file) {
                    return $q(function(resolve) {
                        // SVG 等非位图格式或空文件直接返回 null
                        if (!file || !file.type) {
                            resolve(null);
                            return;
                        }
                        // 只处理 JPEG 和 PNG
                        if (file.type.indexOf('image/jpeg') === -1 && file.type.indexOf('image/png') === -1 && file.type.indexOf('image/jpg') === -1) {
                            resolve(null);
                            return;
                        }

                        try {
                            var reader = new FileReader();
                            reader.onload = function(e) {
                                try {
                                    var arr = new Uint8Array(e.target.result);
                                    var view = new DataView(arr.buffer);
                                    var width, height;

                                    // PNG: 前8字节签名 0x89 50 4E 47 0D 0A 1A 0A
                                    // IHDR chunk 在 offset 8 处，宽高为 offset 16/20，各4字节 big-endian
                                    if (arr[0] === 0x89 && arr[1] === 0x50 && arr[2] === 0x4E && arr[3] === 0x47) {
                                        width = view.getUint32(16);
                                        height = view.getUint32(20);
                                        resolve({ width: width, height: height });
                                        return;
                                    }

                                    // JPEG: 以 0xFF 0xD8 0xFF 开头
                                    // 搜索 SOF (Start of Frame) marker，宽高紧随其后
                                    if (arr[0] === 0xFF && arr[1] === 0xD8 && arr[2] === 0xFF) {
                                        var offset = 2;
                                        var limit = Math.min(arr.length - 9, 65536);
                                        while (offset < limit) {
                                            if (arr[offset] !== 0xFF) {
                                                break;
                                            }
                                            var marker = arr[offset + 1];
                                            // SOF markers: 0xC0 ~ 0xCF (跳过 0xC4 DHT, 0xC8 JPG 扩展)
                                            if ((marker >= 0xC0 && marker <= 0xC3) || (marker >= 0xC5 && marker <= 0xC7) || (marker >= 0xC9 && marker <= 0xCF)) {
                                                height = view.getUint16(offset + 5);
                                                width = view.getUint16(offset + 7);
                                                resolve({ width: width, height: height });
                                                return;
                                            }
                                            // 跳过当前 segment：segment长度(2字节) + marker(2字节)
                                            var segLen = view.getUint16(offset + 2);
                                            if (segLen < 2) break;
                                            offset += 2 + segLen;
                                        }
                                    }

                                    resolve(null);
                                } catch (innerErr) {
                                    resolve(null);
                                }
                            };
                            reader.onerror = function() {
                                resolve(null);
                            };
                            // 只需读取前 64KB 即可找到图片尺寸信息
                            var blob = (typeof file.slice === 'function') ? file.slice(0, 65536) : file;
                            reader.readAsArrayBuffer(blob);
                        } catch (err) {
                            resolve(null);
                        }
                    });
                }

                function filterUpload(files) {
                    $(".save-pages2").removeClass('hide1');
                    // 预处理 .livp 文件：解包提取 HEIC 图片后替换，后续流程无感知
                    extractLivpFiles(files).then(function(processedFiles) {
                        if (processedFiles.length === 0) {
                            $(".save-pages2").addClass('hide1');
                            return;
                        }
                        asyncUpload(processedFiles);
                    });
                }

                // 遍历文件列表，将 .livp 文件解包为真实图片文件，非 .livp 文件原样返回
                function extractLivpFiles(files) {
                    var promises = [];
                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];
                        var fileName = (file.name || '').toLowerCase();
                        if (fileName.endsWith('.livp')) {
                            promises.push(_extractHeicFromLivp(file));
                        } else {
                            promises.push(Promise.resolve(file));
                        }
                    }
                    return Promise.all(promises).then(function(results) {
                        return results.filter(function(f) { return f !== null; });
                    });
                }

                // 从 .livp 压缩包中提取 HEIC 图片，保留原始 .livp 文件名
                function _extractHeicFromLivp(file) {
                    return JSZip.loadAsync(file).then(function(zip) {
                        var imageFileName = null;
                        zip.forEach(function(relativePath, zipEntry) {
                            if (!zipEntry.dir && !imageFileName) {
                                var lowerName = relativePath.toLowerCase();
                                if (lowerName.endsWith('.heic') || lowerName.endsWith('.heif') ||
                                    lowerName.endsWith('.jpg') || lowerName.endsWith('.jpeg') ||
                                    lowerName.endsWith('.png')) {
                                    imageFileName = relativePath;
                                }
                            }
                        });

                        if (!imageFileName) {
                            console.warn('No image found in .livp package:', file.name);
                            return null;
                        }

                        return zip.file(imageFileName).async('blob').then(function(blob) {
                            // 提取内部图片的扩展名
                            var internalExt = '';
                            var internalLower = imageFileName.toLowerCase();
                            if (internalLower.endsWith('.heic')) internalExt = '.heic';
                            else if (internalLower.endsWith('.heif')) internalExt = '.heif';
                            else if (internalLower.endsWith('.jpg') || internalLower.endsWith('.jpeg')) internalExt = '.jpg';
                            else if (internalLower.endsWith('.png')) internalExt = '.png';
                            // 用原始 .livp 文件名替换扩展名
                            var newName = file.name.replace(/\.livp$/i, '') + internalExt;
                            var newFile = new File([blob], newName, { type: blob.type || 'image/heic' });
                            newFile.usenum = 0;
                            newFile.percent = 0;
                            newFile.blobCover = URL.createObjectURL(newFile);
                            newFile.imgSize = blob.size;
                            return newFile;
                        });
                    }).catch(function(err) {
                        console.error('Failed to extract .livp:', file.name, err);
                        return null;
                    });
                }

                function asyncUpload(files) {
                    vm.uploadPhotoItem = files;
                    vm.indd = 0;
                    vm.errorImageArr = [];
                    vm.duplicateList = [];
                    vm.currentFileList = [];
                    $rootScope.$broadcast('uploadStart',true);
                    vm.filesLength = vm.uploadPhotoItem.length;
                    // 并发5个上传：同时启动前5张，之后每完成一张补位启动下一张
                    for (var i = 0; i < 5 && i < files.length; i++) {
                        qiniuUpload(files[i], files, i);
                    }
                }

                // function qiniuUpload(file, files, index_) {
                //     var formData = new FormData();
                //     formData.append('file', file);
                //     formData.append('unique_names', false);
                //     formData.append('key', "gallery-" + UidService.get());
                //     formData.append('token', vm.token);
                //     var reader2 = new FileReader();
                //     reader2.readAsArrayBuffer(file)
                //     file.percent = 20;
                //     reader2.onloadend = function (e) {
                //         formData.append('crc32', CRC32.buf(new Uint8Array(this.result)));
                //         return $.ajax({
                //             // cache: true,
                //             type: "POST",
                //             url: 'https://upload.qiniup.com/',
                //             data: formData,
                //             async: true,
                //             contentType: false,
                //             processData: false,
                //             xhr:function(){
                //                 var myXhr = $.ajaxSettings.xhr();
                //                 if(myXhr.upload){ // check if upload property exists
                //                     myXhr.upload.addEventListener('progress',function(e){
                //                         var loaded = e.loaded;                  //已经上传大小情况
                //                         var total = e.total;                      //附件总大小
                //                         var percent = Math.floor(100*loaded/total)+"%";     //已经上传的百分比
                //                         file.percent = parseInt(100*loaded/total)/2;
                //                     }, false); // for handling the progress of the upload
                //                 }
                //                 return myXhr;
                //             },
                //             success: function (data) {
                //                 vm.uploadPhotoItem[index_].blobCover = $scope.domain +data.key + '?imageView2/1/w/150/h/150';
                //                 file.percent = 80;
                //                 assignGalleries(file, files, index_, data)
                //             },
                //             error: function (request) {
                //                 file.state = 'error';
                //                 vm.errorImageArr.push(files[index_]);
                //                 //最后一个失败了的话
                //                 if (files.length == (Number(vm.indd) + Number(vm.errorImageArr.length))) {
                //                     $timeout(function () {
                //                         $scope.loadingAllSuccess = true;
                //                         updatePic();
                //                     })
                //                 }else{
                //                     var _index1 = Number(index_) + 1;
                //                     if (files.length > _index1) {
                //                         var f = files[index_ + 1];
                //                         qiniuUpload(f, files, _index1);
                //                     }
                //                 }
                //             }
                //         });
                //     }
                // }

                function qiniuUpload(file, files , index_){
                    // 上传前检查图片是否过大，注意此时可能获取不到图片宽高，checkIsBigImage 内部已做兼容处理
                    checkIsBigImage(file).then(function(isBig) {
                        if (isBig) {
                            vm.higherSize.push(file);
                        } else {
                            // 符合规范，执行正常上传流程
                            doUpload(file, files, index_);
                        }
                    });
                }

                // 执行实际上传
                function doUpload(file, files, index_) {
                    ImageService.backendUploadPics(file, $scope.domain, vm.token, function(data, f){
                        file.percent = 80;
                        assignGalleries(file, files, index_, data)
                    },function(err){
                        file.state = 'error';
                        vm.errorImageArr.push(files[index_]);
                        proceedToNext(file, files, index_);
                    })
                }

                // 处理当前文件后继续下一张
                function proceedToNext(file, files, index_) {
                    //最后一个失败了的话
                    if (files.length == (Number(vm.indd) + Number(vm.errorImageArr.length))) {
                        $timeout(function () {
                            $scope.loadingAllSuccess = true;
                            updatePic();
                        })
                    }else{
                        // 并发5：前5张已同时启动，此后每完成一张（index_ >= 4）补位启动下一张
                        if (files.length > Number(index_) + 1 && index_ >= 4) {
                            var f = files[Number(index_) + 1];
                            qiniuUpload(f, files, Number(index_) + 1);
                        }
                    }
                }

                function serviceUpload(data, file,callback) {
                    //非冲印的上传 需要增加detectFaces为true
                    var detectFaces = $state.current.name !== "editorPhotoBothEdit" && $state.current.name !== 'editorPhotoBoth'

                    Gallery.upload({
                        identifiers: data.key,
                        provider: "QINIU",
                        fileName: file.name,
                        imgSize: file.size,
                        width: file.width,
                        height: file.height,
                        folderId: vm.folderOne ? vm.folderOne.id : '',
                        check: true,
                        type: vm.uploadType,
                        articleId:vm.aid,
                        hash: data.hash,
                        detectFaces:detectFaces
                    }, function (resp1) {
                        file.percent = 100;
                        var resp = resp1.data;
                        file.id = resp.id;
                        file.cancelled = resp.cancelled;
                        vm.indd++;
                        file.state = 'success';
                        if (!resp.cancelled) {
                            resp.identifier = $scope.domain +resp.identifier;
                            if(resp.duplicate){
                                vm.duplicateList.push(resp)
                            }
                            if(vm.photoAll){
                                vm.photoAll.push(resp)
                            }
                            if(vm.qiniuId){
                                resp.usenum = 0;
                                resp.loading = true;
                                vm.qiniuId.push(resp)
                            }
                            if(vm.onUploadphoto){
                                vm.onUploadphoto({text:resp})
                            }
                            vm.currentFileList.push(resp)

                        }
                        if(callback){callback()}
                    }, function (error) {
                        file.state = 'error';
                        vm.errorImageArr.push(file);
                        if(callback){callback()}
                    });
                }


                function assignGalleries(file, files, index_, data) {
                    serviceUpload(data, file,function () {
                        if (files.length == (Number(vm.indd) + Number(vm.errorImageArr.length))) {
                            $timeout(function () {
                                $scope.loadingAllSuccess = true;
                                updatePic();
                            })
                        }else{
                            // 并发5：前5张已同时启动，此后每完成一张（index_ >= 4）补位启动下一张
                            if (files.length > Number(index_) + 1 && index_ >= 4) {
                                var f = files[Number(index_) + 1];
                                qiniuUpload(f, files, Number(index_) + 1);
                            }
                        }
                    });
                }
                $scope.errorImageArr_=[];
                $scope.reUpload = function () {
                    $scope.errorImageArr_.forEach(function (item) {
                        item.percent = 0;
                        item.state = null;
                    });
                    $scope.errorImageHide();
                    $(".save-pages2").removeClass('hide1');
                    asyncUpload($scope.errorImageArr_);
                }
                // 上传图片后更新图片库/文件夹
                vm.successSum = 0;
                function updatePic() {
                    $scope.isLookErrorImages = false;
                    $(".save-pages2").addClass('hide1');
                    vm.uploadPhotoItem = [];
                    // 广播重复图片列表
                    if (vm.duplicateList && vm.duplicateList.length > 0) {
                        $rootScope.$broadcast('duplicateImages', angular.copy(vm.duplicateList),vm.errorImageArr.length>0 ? false : true,vm.currentFileList);
                    }else{
                        $rootScope.$broadcast('uoloadFinished',vm.errorImageArr.length>0 ? false : true);
                    }

                    console.log(vm.errorImageArr)
                    vm.successSum = angular.copy(vm.indd);
                    $timeout(function () {
                        vm.indd = 0;
                        vm.filesLength = 0;
                        //如果没有上传错误图片，关闭提示框
                        if(vm.errorImageArr.length === 0){
                            $scope.loadingAllSuccess = false;
                        }else{
                            $scope.loadingAllSuccess = true;
                        }
                    },2000)
                }
                //关闭上传错误弹窗
                $scope.closeErrorMoadl = function (){
                    var target = event.target;
                    if($(target).hasClass("z-modal") || $(target).hasClass("close-btn") || $(target).hasClass("close-icon1")){
                        $scope.loadingAllSuccess = false;
                    }
                    if(vm.duplicateList.length == 0){
                        $rootScope.$broadcast('uoloadFinished',true);
                    }
                }
                //上传进度获取
                $scope.schedule = function () {
                    if(vm.filesLength > 0){
                        return Number(vm.indd)+vm.errorImageArr.length + '/' + vm.filesLength
                    }
                }
                $scope.errorImageArrCb = function () {
                    return vm.errorImageArr.length
                }
                $scope.successImageArrCb = function () {
                    return vm.indd || vm.successSum
                }
                $scope.isLookErrorImages = false;
                $scope.lookErrorImages = function () {
                    $scope.isLookErrorImages = true;
                    $scope.loadingAllSuccess = false;
                    $scope.errorImageArr_ = vm.errorImageArr;
                    $scope.errorImageArr_.forEach(function (item) {
                        item.percent = 0;
                    })
                };
                $scope.errorImageHide = function () {
                    $scope.isLookErrorImages = false;
                    $rootScope.$broadcast('uoloadFinished',true);
                }

                function threeInfo(item){
                    $scope.threeError = true;
                    $scope.threeErrorText=item;
                    $timeout(function () {
                        $scope.threeError = false;
                        $scope.threeErrorText="";
                    },1500)
                }
            }]
    };

    angular
        .module('editorApp')
        .component('uploadImage', uploadImage);
})();
